<template>
    <div :class="['questionnaire-menu row visible-on']">
        <div class="shadow">
        <div class="first-row">
            <div class="logo small-logo" @click="toHomePage"><img v-if="logo" :src="logo" alt=""></div>
            <div class="menu">
                <div v-clickoutside="closeLanguageMenu" v-if="languages && languages.length > 0" class="language-menu">
                    <div class="language-button" @click="toggleLang()">
                      <span class="text">{{ $t('questionnaire.label.language') }}</span>
                      <span class="arrow icomoon-arrow-down"></span>
                    </div>
                </div>
                <div v-clickoutside="closePageMenu" v-if="menus && menus.length > 0" class="page-menu">
                    <div class="menu-button" @click="toggleMenu()">
                      <span class="icon iconfont iconlianggehengxian"></span>
                    </div>
                    <div class="page-menu-drop-down" v-show="isMenuShow">
                      <div class="menu-options">
                        <div
                          :class="['menu-option', index > 0 ? 'has-top-border' : '']"
                          v-for="(menu, index) in menus"
                          :key="index"
                          @click="toLink(menu.link)">
                          <span>{{ menu.text }}</span>
                          <span class="icon iconfont right-arrow iconarrow-right"></span>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="first-row second-row">
            <div class="menu">
                <div class="language-menu" v-show="isLangShow">
                    <div class="language-options"><div :class="['language-option', index > 0 ? 'has-top-border' : '']" v-for="(lang, index) in languages" :key="index" @click="switchLang(lang.id)">{{ lang.text }}</div></div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import moment from 'moment'
import { LOCAL_LANGUAGE_KEY } from '@/constant/common'
import { questionnaireMixin } from '@/components/questionnaire/form/mixin.js'
// @logo: the url of the logo displayed on the left of the menu.
// @languages: the languages dict array used to switch language.
// @menus: the menus dict array displayed on the right of the menu.

export default {
  directives: {
    Clickoutside
  },
  mixins: [questionnaireMixin],
  props: ['logo', 'languages', 'menus'],
  data () {
    return {
      isLangShow: false,
      isMenuShow: false
    }
  },
  computed: {
    hasLogin () {
      const currentAccount = this.$parent.$parent.currentAccount
      return currentAccount && currentAccount.id
    }
  },
  methods: {
    closePageMenu () {
      this.isMenuShow = false
    },
    closeLanguageMenu () {
      this.isLangShow = false
    },
    toggleLang () {
      this.isMenuShow = false
      this.isLangShow = !this.isLangShow
    },
    toggleMenu () {
      this.isLangShow = false
      this.isMenuShow = !this.isMenuShow
    },
    switchLang (lang) {
      this.$i18n.locale = lang
      localStorage.setItem(LOCAL_LANGUAGE_KEY, lang)
      this.isLangShow = false
      const current = moment.locale()
      let locale = 'en'
      if (lang === 'zh') {
        locale = 'zh-cn'
      } else if (lang === 'tw') {
        locale = 'zh-tw'
      } else if (lang === 'hk') {
        locale = 'zh-hk'
      }
      if (current !== locale) {
        moment.locale(locale)
        this.$eventBus.$emit('momentLocaleChange')
      }
    },
    toLink (url) {
      if (!url) {
        return
      }
      if (url.indexOf('https://') > -1 || url.indexOf('http://') > -1) {
        this.toOutSide(url)
      } else {
        this.toVuePage(url)
      }
      this.isMenuShow = false
    },
    toHomePage () {
      if (this.logo && this.hasLogin) {
        const homePath = this.$parent.$parent.getQuestionnaireHomePath()
        if (!homePath || homePath === this.$route.path) {
          return
        }
        this.$router.push(homePath)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '~@/assets/iconfont/iconfont.css';
@import '~@/assets/icomoon/style.css';
.questionnaire-menu {
  height: 60px;
  z-index: 100;
  width: 100%;
  .first-row {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 60px;
    .logo {
        user-select: none;
        flex: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        max-width: 100px;
        max-height: 40px;
        cursor: pointer;
        img {
            width: 120px;
            height: 40px;
        }

        &.small-logo {
          max-width: 40px;
          img {
            width: 40px;
          }
        }
    }
    .menu {
        user-select: none;
        flex: 0.8;
        width: 200px;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
        .language-menu {
            margin-right: 50px;
            text-align: center;
            width: 100px;
            cursor: pointer;
            span {
                user-select: none;
                font-size: large;
            }
            .text {
                position: relative;
                top: -3px;
                margin-right: 8px;
            }
        }
        .page-menu {
            width: 50px;
            cursor: pointer;
            position: relative;
            span {
                user-select: none;
                font-size: large;
            }
        }
    }
  }
  .has-top-border {
      border-top: solid 1px gray;
  }
  .option {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: medium;
    height: 40px;
    cursor: pointer;
  }
  .options {
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .right-arrow {
      color: black;
      position: absolute;
      left: 220px;
  }
  .second-row {
      user-select: none;
      width: 100%;
      height: 120px;
      position: absolute;
      display: flex;
      .language-menu {
        position: relative;
        .language-options {
            @extend .options;
            width: 150px;
            height: 120px;
            .language-option {
                @extend .option;
                width: 120px;
            }
        }
      }
  }
  .page-menu-drop-down {
    position: absolute;
    right: 20px;
    z-index: 1000;

    .menu-options {
      @extend .options;
      width: 260px;
      height: 120px;

      .menu-option {
        @extend .option;
        width: 220px;
        cursor: pointer;
      }
    }
  }
}
@media (max-width: 767px) {
  .option-mobile {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: medium !important;
    height: 40px !important;
  }
  .options-mobile {
    background-color: white !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
    .questionnaire-menu {
        position: absolute !important;
        padding-left: 1.8rem !important;
        .first-row {
            height: 40px;
            // display: block;
            margin: 0 auto;
            .logo {
                width: 100px !important;
                height: 40px !important;
                img {
                    width: 100px !important;
                    height: 40px !important;
                }
                &.small-logo {
                  img {
                    width: 40px !important;
                  }
                }
            }
            .menu {
                position: relative;
                width: 200px !important;
                height: 40px;
                .language-menu {
                    width: 100px !important;
                    margin-right: 0 !important;
                    span {
                        color: white !important;
                        font-size: medium !important;
                    }
                    .text {
                        color: white !important;
                        font-size: medium !important;
                        top: -2px !important;
                    }
                }
                .page-menu {
                    width: 3rem !important;
                    position: relative;
                    right: -10px;
                    .menu-button {
                      span {
                        color: white !important;
                        font-size: large !important;
                      }
                    }
                }
            }
        }
        .second-row {
            width: 99% !important;
            height: 120px !important;
            position: absolute !important;
            display: flex !important;
            .language-menu {
                position: relative !important;
                left: -3.5rem !important;
                margin-right: 0 !important;
                .language-options {
                    @extend .options-mobile;
                    width: 150px !important;
                    height: 120px !important;
                    .language-option {
                        @extend .option-mobile;
                        width: 120px !important;
                    }
                }
            }

        }
    }

  .page-menu-drop-down {
    .menu-options {
      @extend .options-mobile;
      width: 240px !important;
      height: 120px !important;

      .menu-option {
        @extend .option-mobile;
        width: 220px !important;

        span {
          font-size: medium !important;
        }
      }
    }
  }
}
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .language-menu {
        left: -20px !important;
    }
    .right-arrow {
      left: 230px !important;
    }
    .page-menu-drop-down {
        .menu-options {
            width: 260px !important;
            height: 120px !important;
            .menu-option {
                width: 220px !important;
            }
        }
    }
}

/* 中型设备（台式电脑，992px 起） */
@media (min-width: 992px) {
    .language-menu {
        left: -10px !important;
    }
    .right-arrow {
      left: 230px !important;
    }
    .page-menu-drop-down {
        .menu-options {
            width: 260px !important;
            height: 120px !important;
            .menu-option {
                width: 220px !important;
            }
        }
    }
}

/* 大型设备（大台式电脑，1200px 起） */
@media (min-width: 1200px) {
    .language-menu {
        left: 10px !important;
    }
    .right-arrow {
      left: 230px !important;
    }
    .page-menu-drop-down {
        .menu-options {
            width: 260px !important;
            height: 120px !important;
            .menu-option {
                width: 220px !important;
            }
        }
    }
}

/* 大型设备（大台式电脑，1200px 起） */
@media (min-width: 1367px) {
    .language-menu {
        left: 35px !important;
    }
    .right-arrow {
      left: 230px !important;
    }
    .page-menu-drop-down {
        .menu-options {
            width: 260px !important;
            height: 120px !important;
            .menu-option {
                width: 220px !important;
            }
        }
    }
}
</style>
